<template>
  <div class="gameLists">
    <template v-if="list.length">
    <div :class="['gameListsItem', itemClass]" v-for="(item, i) in list" :key="i">
      <div v-if="isLoggedin && showFavorite" class="absolute-rt-1 size-4 rounded-full bg-black/50 [&>img]:size-full z-[5]" @click="toggleFavorite(item)">
        <!-- <van-loading v-if="item._loading" type="spinner" size="16" class="absolute-rt-0" /> -->
        <img v-if="favGamelist.some(code => item.code === code)" src="@a/assets/images/collect.png" alt=""/>
        <img v-else src="@a/assets/images/uncollect.png" alt=""/>
      </div>
      <Image :lazy-load :key="item.code" :src="item.customIcon || item.icon" @click="onClickItem(item, $router)" class="size-full">
        <template #loading>
          <!-- <van-loading type="spinner" size="20" /> -->
          <img src="/static/images/default_img.png" class="size-full object-cover" alt=""/>
        </template>
        <template #error>
          <img src="/static/images/default_img.png" class="size-full object-cover" alt=""/>
        </template>
      </Image>
        <span class="gName" v-if="item.name">{{ item.customName }}</span>
      </div>
    </template>
    <div v-else-if="placeholderCount > 0" :class="['gameListsItem placeholder', itemClass]" v-for="item in placeholderCount" :key="item">
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { iGame } from '@/types/index'
  import type { Router } from 'vue-router'
  import { gotoGame } from '@/utils'
  // import Image from '@/components/Image/index.tsx'
  // import * as api from '@/api'
  import { useUserInfo, useFavGamelist } from '@/store'
  
  withDefaults(defineProps<{
    list: (iGame & { _loading?: boolean })[]
    onClickItem?: (item: iGame, router: Router) => void
    itemClass?: string
    showFavorite?: boolean
    placeholderCount?: number
    lazyLoad?: boolean
  }>(), {
    onClickItem: gotoGame,
    showFavorite: false,
    placeholderCount: 0,
    lazyLoad: false
  })

  const favGamelist = computed(() => useFavGamelist().list)
  const toggleFav = useFavGamelist().toggleFavorite
  const toggleFavorite = async (item) => {
    if (item._loading) return

    item._loading = true
    try {
      await toggleFav(favGamelist.value.some(code => item.code === code), item.code)
    } finally {
      item._loading = false
    }
  }

  const isLoggedin = useUserInfo().isLoggedin

</script>

<style scoped lang="scss">
  .gameLists {
    @apply flex flex-wrap;

    .gameListsItem{
      @apply rounded-[5px] overflow-hidden relative;
    }

    .gName {
      @apply absolute-[auto_0_0] font-[600] leading-[20px] text-center bg-[#D9D9D9]/20 truncate px-1 text-11;
    }
    
    .placeholder {
      @apply bg-[var(--theme-gray10)] opacity-50;
    }
  }
</style>
